const GlobeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.4" />
        <path d="M2 8h12M8 2c2 2 2 10 0 12M8 2c-2 2-2 10 0 12" stroke="currentColor" strokeWidth="1.2" />
    </svg>
);

const currentYear = new Date().getFullYear();

export const Footer = () => (
    <footer className="footer">
        <div className="footer__inner">
            <span>© ShareGate {currentYear}</span>
            <a href="https://sharegate.com/terms" target="_blank" rel="noreferrer">Terms</a>
            <a href="https://sharegate.com/sub-processors" target="_blank" rel="noreferrer">Sub-Processors</a>
            <a href="https://sharegate.com/data-privacy" target="_blank" rel="noreferrer">Data Privacy Addendum</a>
            <a href="https://sharegate.com/modern-slavery-statement" target="_blank" rel="noreferrer">Modern Slavery Statement</a>
            <a href="https://sharegate.com/privacy" target="_blank" rel="noreferrer">Privacy</a>
            <button className="footer__lang" type="button" aria-label="Change language">
                <GlobeIcon /> Français
            </button>
        </div>
    </footer>
);
